import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

import { Observable } from 'rxjs';

import { PrintModule } from './print.module';
import { PrintService } from './print.service';

@Component({
    imports: [PrintModule, AsyncPipe],
    selector: 'ms-print-container',
    templateUrl: './print-container.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrintContainerComponent implements OnInit {
    url$: Observable<SafeUrl>;

    constructor(private printService: PrintService) {}

    ngOnInit(): void {
        this.url$ = this.printService.getPrintUrl();
    }
}
